import { joinUtil, joinResult } from "../../../public/join_util";
import ViewBase from "../../../../framework/core/mvvm/view_base";
import EventManager from "../../../../manager/event_manager";
import SceneManager from "../../../../manager/scene_manager";
import MVVMBase from "../../../../framework/core/mvvm/mvvm_base";
import Module from "../../../../framework/core/mvvm/module_base";
import ModelBase from "../../../../framework/core/mvvm/model_base";
import UserDataManager, { IUserCurrencyData } from "../../../../manager/user_manager";
import ModelData from "../../../public/model_data";
import AppData from "../../../public/const/app_data";

const {ccclass,menu,property} = cc._decorator;

@ccclass
export class ContinueCom extends cc.Component {

    @property(cc.Button)
    public readonly continute : cc.Button = null;

    @property(ViewBase)
    public viewBase : ViewBase = null;

    private isLeave : boolean = false;

    onLoad(){

        if (!this.viewBase) {
            let parent = this.node
            while (parent != null) {
                this.viewBase = parent.getComponent<ViewBase>(ViewBase)
                if (this.viewBase != null) {
                    break;
                }
                parent = parent.parent
            }
        }
    }

    onEnable(){
        
        this.continute.node.on("click",()=>{            

            //joinUtil.checkInTable(this.viewBase); 
        });

        this.continute.node.active = false;
        
        EventManager.instance.off("event_exit_game",this.onExitGame,this);
        EventManager.instance.on("event_exit_game", this.onExitGame,this,true);

        EventManager.instance.off("event_avatar_leave",this.onAvatarLeave,this);
        EventManager.instance.on("event_avatar_leave", this.onAvatarLeave,this,true);
        
    }


    onDisable(){

        EventManager.instance.off("event_exit_game",this.onExitGame,this);
        EventManager.instance.off("event_avatar_leave",this.onAvatarLeave,this);

        this.isLeave = false;
    }

    private onExitGame(){

        if (this.isLeave) {
         
            SceneManager.gotoHallOrClubHall("TabelExit");
        }        
    }

    private onAvatarLeave(goldId : number,module : Module< ViewBase,ModelBase>){

        //筹码不够小于离场下限,需要充值 / 筹码太多超过离场上限,需要转场                   

        let self = this;
        this.isLeave = true;
        this.continute.node.active = false;   
        
    }

  

}